import $ from 'dom7';

export class usadosFunciones {

    // Defino variable global
    get servicioGlobal () {
        // return 'http://localhost:8888'
        return 'https://apiusados.cdms.com.ar'
    }

    get imagenesGlobal () {
      let upload_directory = this.servicioGlobal + '/uploads';
      return upload_directory
  }

    /*
    SECCION USADOSABM
    */

    // Carga lo datos de un vehiculo en la pantalla de edicion
    listarVehiculo($f7, vehiculoID){
      let url = this.servicioGlobal + '/datos-vehiculos/getAll/' + vehiculoID;
      
      $f7.request({
        url: url,
        method: 'get',
        success: function (data, status, xhr) {
          let informacion = JSON.parse(data);

          if(informacion.cantidad > 0){
            let vehiculos = informacion.vehiculos;

            vehiculos.forEach(element => {
              $('#patente').val(element.patente);
              $('#anio').val(element.anio);
              $('#kilometros').val(element.kilometros);
              $('#color').val(element.color);
              $('#comentario').val(element.descripcion);
            });

          }else{
            $f7.dialog.alert('No existen datos del vehiculo para mostrar')
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    }

    // Carga el listado con todos lo vehiculos en la pantalla principal
    // +++++ Esta faltando que muestre los de usuario logueado
    // +++++ Esta faltando la paginacion del listado

    listarVehiculos ($f7, user){
      $('#listadoUsados').empty();
      
      let url = this.servicioGlobal + '/datos-vehiculos/getAll';
      if(user){
          url = this.servicioGlobal + '/datos-vehiculos/getAll/' + user;
      }
      
      $f7.request({
        url: url,
        method: 'get',
        data: {'vehiculo': user },
        success: function (data, status, xhr) {
          let informacion = JSON.parse(data);

          if(informacion.cantidad > 0){
            let vehiculos = informacion.vehiculos;
            let contenido = '';
            vehiculos.forEach(element => {
              contenido += '<li> \n' +
                            '<a href="/abm/?id='+element.id+'&marca='+element.idmarca+'&modelo='+element.idmodelo+'&version='+element.idversion+'" class="item-link item-content"> \n' +
                              '<div class="item-media"><img src="https://www.chevrolet.com.ar/content/dam/chevrolet/mercosur/argentina/espanol/index/cars/cars-subcontent/01-images/chevrolet-autos-joy-hb.jpg?imwidth=1200" \n' +
                                  'width="80" /></div> \n' +
                              '<div class="item-inner"> \n' +
                                '<div class="item-title-row"> \n' +
                                  '<div class="item-title">'+element.marca+'</div> \n' +
                                  '<div class="item-after"><span style="font-weight:bold;color:#000">'+element.anio+'</span></div> \n' +
                                '</div> \n' +
                                '<div class="item-subtitle">'+element.modelo+'</div> \n' +
                                '<div class="item-text">'+element.patente+'</div> \n' +
                              '</div> \n' +
                            '</a> \n' +
                          '</li>';
            });
            $('#listadoUsados').append(contenido);
          }else{
            $f7.dialog.alert('No existen vehiculos para mostrar')
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    }

    // Gurdar / Actualizar datos principales
    saveVehiculos($f7, form){
      let formData = $f7.form.convertToData('#'+form);
      let url = this.servicioGlobal + '/datos-vehiculos/saveVehiculo';

      $f7.request({
        url: url,
        method: 'post',
        // dataType: 'json',
        data: formData,
        success: function (data, status, xhr) {
          let informacion = JSON.parse(data);
          if(informacion.Error == 0){
            $f7.dialog.alert(informacion.Mensaje);
            $('#btn-imagen-color').css('color', '#00b33c');
            $('#btn-href-url').attr("href", '/usadosimagenes/?id_vehiculo='+informacion.Vehiculo_id); // debo agregar el numero de vehiculo
          }else{
            $f7.dialog.alert(informacion.Mensaje);
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });

    }

    // Funciones para carga de desplegables
    getMarcas($f7, marcaID) {
      let url = this.servicioGlobal + '/datos-vehiculos/marcas';
      $('#get-marcas').empty();
      
      $f7.request({
        url: url,
        method: 'get',
        success: function (data, status, xhr) {
          let informacion = JSON.parse(data);

          if(informacion.cantidad > 0){
            let marcas = informacion.marcas;
            let contenido = '<option value="0">Seleccionar ...</option>';
            marcas.forEach(element => {
              let selected = (marcaID == element.idmarca && marcaID != 0) ? ' selected' : '';
              if(marcaID == element.idmarca && marcaID != 0){
                $('#get-marcas-title').html(element.marca);
              }
              contenido += '<option value="'+element.idmarca+'"'+selected+'>'+element.marca+'</option>';
            });
            $('#get-marcas').append(contenido);
          }else{
            console.log('No existen marcas para mostrar')
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    }

    getModelos($f7, marcaID, modeloID) {
      let url = this.servicioGlobal + '/datos-vehiculos/modelos/' + marcaID;
      $('#get-modelos').empty();
      
      $f7.request({
        url: url,
        method: 'get',
        success: function (data, status, xhr) {
          let informacion = JSON.parse(data);

          if(informacion.cantidad > 0){
            let modelos = informacion.modelos;
            let contenido = '<option value="0">Seleccionar ...</option>';
            modelos.forEach(element => {
              let selected = (modeloID == element.idmodelo && modeloID != 0) ? ' selected' : '';
              if(modeloID == element.idmodelo && modeloID != 0){
                $('#get-modelos-title').html(element.descripcion);
              }
              contenido += '<option value="'+element.idmodelo+'"'+selected+'>'+element.descripcion+' ('+element.anio+')</option>';
            });
            $('#get-modelos').append(contenido);
          }else{
            console.log('No existen modelos para mostrar');
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    }

    getVersiones($f7, modeloID, versionID) {
      let url = this.servicioGlobal + '/datos-vehiculos/versiones/' + modeloID;
      $('#get-versiones').empty();
      
      $f7.request({
        url: url,
        method: 'get',
        success: function (data, status, xhr) {
          let informacion = JSON.parse(data);

          if(informacion.cantidad > 0){
            let modelos = informacion.modelos;
            let contenido = '<option value="0">Seleccionar ...</option>';
            modelos.forEach(element => {
              let selected = (versionID == element.idversion && versionID != 0) ? ' selected' : '';
              if(versionID == element.idversion && versionID != 0){
                $('#get-versiones-title').html(element.descripcion);
              }
              contenido += '<option value="'+element.idversion+'"'+selected+'>'+element.descripcion+'</option>';
            });
            $('#get-versiones').append(contenido);
          }else{
            console.log('No existen veriones para mostrar');
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    }

    /*
    SECCION USADOSIMAGENES
    */

    // Mostrar listado con las imagenes correspondientes a un peritaje
    listarImagenes($f7, vehiculoID){
      let t = new Date().getTime();
      $("#get-imagenes").empty();
      let url = this.servicioGlobal + '/datos-vehiculos/getAllImagenes/' + vehiculoID;
      $f7.request({
        url: url,
        method: 'get',
        success: function (data, status, xhr) {
          let informacion = JSON.parse(data);

          if(informacion.cantidad > 0){
            let imagenes = informacion.imagenes;
            let contenido = '';
            imagenes.forEach(element => {
              contenido += '<div class="card demo-facebook-card" id="imagen-'+element.idimagen+'"> \n' +
              '<div class="card-content card-content-padding"> \n' +
                '<img src="'+element.pathimagen + '?t=' + t +'" width="100%" /> \n' +
                '<p class="likes">'+element.comentario+'</p> \n' +
              '</div> \n' +
              // La opcion de eliminar se deja como opcion para el backend
              // '<div class="card-footer"><a href="/editarImagen/'+vehiculoID+'/'+element.idimagen+'/" class="link edit-imagen" data-imagen="'+element.idimagen+'">Editar</a><a href="/eliminarImagen/'+vehiculoID+'/'+element.idimagen+'/" class="link delete-imagen" style="color:red" data-imagen="'+element.idimagen+'">Eliminar</a></div> \n' +
              '<div class="card-footer"><a href="/eliminarImagen/'+vehiculoID+'/'+element.idimagen+'/" class="link delete-imagen" style="color:red" data-imagen="'+element.idimagen+'">Eliminar</a></div> \n' +
            '</div>';
            });
            $('#get-imagenes').append(contenido);

          }else{
            console.log('No existen imagenes para mostrar');
          }

        },
        statusCode: {
          404: function (xhr) {
            alert('Servicio no encontrado');
          }
        }
      });
    }

    addImageneSubida($f7, imagenName, imagenID, vehiculoID){
    let t = new Date().getTime();
    let url = this.servicioGlobal + '/datos-vehiculos/getRuta';

    $f7.request({
      url: url,
      method: 'get',
      success: function (data, status, xhr) {
        let informacion = JSON.parse(data);

        if(informacion.Ruta){
          let contenido = '';
          contenido += '<div class="card demo-facebook-card" id="imagen-'+imagenID+'"> \n' +
            '<div class="card-content card-content-padding"> \n' +
            '<img src="'+ informacion.Ruta+imagenName + '?t=' + t +'" width="100%" /> \n' +
            '<p class="likes"></p> \n' +
            '</div> \n' +
            '<div class="card-footer"><a href="/eliminarImagen/'+vehiculoID+'/'+imagenID+'/" class="link delete-imagen" style="color:red" data-imagen="'+imagenID+'">Eliminar</a></div> \n' +
          '</div>';
      
          $('#get-imagenes').append(contenido);
          $('#save-imagen').hide();
        }else{
          console.log('La ruta para imagenes no se encuentra definida');
        }

      },
      statusCode: {
        404: function (xhr) {
          alert('Servicio no encontrado');
        }
      }
    });


    
    }

    eliminarImagen(app, imagenID, router){
      let url = this.servicioGlobal + '/datos-vehiculos/delImagen/'+imagenID;
      app.request.get(url)
      .then(function (res) {
        // app.views.main.router.back(); // funciona
        // app.views.main.router.refreshPage()
        $('#imagen-' + imagenID).hide();
        console.log('#imagen-' + imagenID);
        
      })
      .catch(function (err) {
        console.log(err.xhr)
        console.log(err.status)
        console.log(err.message)
      })
    }

    editarImagen(imagenID){
      alert('Editar: ' + imagenID);
    }

    saveImagen(){
      console.log('desde calse');
      return false;
    }
}